import { render, staticRenderFns } from "./SSOError.vue?vue&type=template&id=7f68e543&scoped=true&"
import script from "./SSOError.vue?vue&type=script&lang=js&"
export * from "./SSOError.vue?vue&type=script&lang=js&"
import style0 from "./SSOError.vue?vue&type=style&index=0&id=7f68e543&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f68e543",
  null
  
)

export default component.exports